import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import useModalToggle from "../../custom_hooks/useModalToggle";
import svg38 from "../../assets/svg/svg38.svg";
import svg27 from "../../assets/svg/svg27.svg";
import FunnelSimple from "../../assets/svg/FunnelSimple.svg";
import CardLoading from "../../components/CardLoading";
import {
  capitalize,
  dateForHumans,
  numberWithCommas,
  timeAmPm,
} from "../../utils";
import flash from "../../assets/svg/Flash.svg";
import BreadCrumb from "../../layout/BreadCrumb";
import svg67 from "../../assets/svg/svg67.svg";
import { fetchManualReceipt } from "../../features/fetch/fetchSlice";
import FilterModal from "./modal/FilterModal";
import { Dropdown, Spin, Table } from "antd";
import toast from "react-hot-toast";
import DeleteModal from "../../components/DeleteModal";
import ManualReceiptModal from "./modal/ManualReceiptModal";
import { deleteReceipt } from "../../features/delete-setting/deleteSlice";

function ManualReceiptTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { open, handleCancel, handleOpen } = useModalToggle();
  const { saving } = useSelector((state) => state.save);
  const { loading, receiptCount, receiptData } = useSelector(
    (state) => state.fetch
  );

  const [prodd, setProdd] = useState();

  const [openAdd, setOpenAdd] = useState(false);
  const handleOpenAdd = async () => {
    await setProdd("");
    await setOpenAdd(true);
  };
  const handleCancelAdd = () => {
    setOpenAdd(false);
  };

  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deleteReceipt({
        mrId: prodd?.mrId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchTableData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [searchText, setSearchText] = useState("");
  const [filters, setFilters] = useState([]);
  const [formData, setFormData] = useState({});
  const showModalFilter = () => {
    handleOpen();
  };

  const handleClearFilters = async () => {
    await setFormData({});
    await setFilters([]);
    await dispatch(
      fetchManualReceipt({
        url: "api/v1/receipts/fetch-manual-receipts",
        mrOrgId: null,
        mrReceiverMobileNo: null,
        mrBeneficiaryAccount: null,
      })
    );
  };

  const [activeBtn, setActiveBtn] = useState(null);
  const handleClick = async (item) => {
    await setActiveBtn(item);
    dispatch(
      fetchManualReceipt({
        url: "api/v1/receipts/fetch-manual-receipts",
        mrStatus: item,
      })
    );
  };

  const handleEdit = () => {
    setOpenAdd(true);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex  text-[16px] font-sans  !text-lightBlack"
        >
          Edit
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <div
          onClick={showModalDelete}
          className="flex  text-[16px] font-sans   !text-lightBlack"
        >
          Delete
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "Receipt Date",
      dataIndex: "mrReceiptDate",
      render: (item) => {
        return <div>{dateForHumans(item)}</div>;
      },
      sorter: (a, b) => a.mrReceiptDate - b.mrReceiptDate,
    },
    
    {
      title: "Payment Type",
      dataIndex: "mrReceiptType",
      sorter: (a, b) => a.mrReceiptType.localeCompare(b.mrReceiptType),
    },
    {
      title: "Organization Name",
      dataIndex: "orgName",
      sorter: (a, b) => a.orgName.localeCompare(b.orgName),
    },
       {
      title: "Wallet Name",
      dataIndex: "mrWalName",
      sorter: (a, b) => a.mrWalName.localeCompare(b.mrWalName),
    },

    {
      title: "Total Amount",
      dataIndex: "mrReceiptAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.mrReceiptAmount - b.mrReceiptAmount,
    },
    {
      title: "National Id",
      dataIndex: "mrIdNumber",
      sorter: (a, b) => a.mrIdNumber - b.mrIdNumber,
    },
    {
      title: "Receiver Phone",
      dataIndex: "mrReceiverMobileNo",
      sorter: (a, b) =>
        a.mrReceiverMobileNo.localeCompare(b.mrReceiverMobileNo),
    },
    {
      title: "Bank",
      dataIndex: "mrBeneficiaryBank",
      sorter: (a, b) =>
        a.mrBeneficiaryBank.localeCompare(b.mrBeneficiaryBank),
    },
    {
      title: "Benefitiary Account",
      dataIndex: "mrBeneficiaryAccount",
      sorter: (a, b) =>
        a.mrBeneficiaryAccount.localeCompare(b.mrBeneficiaryAccount),
    },
    {
      title: "Intiator",
      dataIndex: "mrInitiatedBy",
      sorter: (a, b) => a.mrInitiatedBy.localeCompare(b.mrInitiatedBy),
    },
    {
      title: "Status",
      dataIndex: "mrStatus",
      render: (item) => {
        const colors = {
          APPROVED: "#2E8B57",
          PENDING: "#FFC107",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: capitalize("Manual Receipting"),
    },
  ];

  async function fetchTableData(page, size) {
    dispatch(
      fetchManualReceipt({
        url: "api/v1/receipts/fetch-manual-receipts",
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading) return <CardLoading />;

  return (
    <>
      <div className="flex flex-col w-full h-full overflow-y-scroll">
        <div className="mb-10">
          <div className="justify-between items-center white_card">
            <BreadCrumb
              breadList={breadList}
              header={"Manual Receipt"}
              info={"Here’s an overview of your Manual Receipt"}
              btn={true}
              btnTitle="Initiate Manual Receipt"
              btnSvg={flash}
              onClick={handleOpenAdd}
            />
          </div>

          <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
            <div className="flex flex-col w-full lg:px-10 px-3 ">
              <h3 className="font-[700] text-[24px] text-lightBlack dash-title mt-[1.25rem]">
                Manual Receipt Details
              </h3>
              <div className="mt-5 flex lg:flex-row flex-col gap-y-5 justify-between lg:items-center items-start w-full">
                <div className="flex items-center">
                  <span>
                    {" "}
                    <button
                      onClick={showModalFilter}
                      type="button"
                      className={`bg-transparent flex items-center gap-x-'1' ${
                        Object?.keys(formData)?.length > 0
                          ? "!text-[#5688E5]"
                          : "inherit"
                      }`}
                    >
                      <img src={FunnelSimple} alt="FunnelSimple" />
                      Filters
                    </button>
                  </span>
                  {Object?.keys(formData)?.length > 0 && (
                    <span className="flex items-center text-[#5688E5] cursor-pointer ml-1">
                      :{Object?.keys(formData)?.length}
                      <img
                        src={svg38}
                        alt="svg38"
                        onClick={handleClearFilters}
                      />
                    </span>
                  )}
                </div>
              </div>
              <div className="flex   flex-wrap    items-center gap-x-14 mb-2  w-auto p-1.5">
                <button
                  onClick={() => handleClick(null)}
                  className={`${
                    activeBtn === null
                      ? "text-[#146ADC] border border-[#146ADC]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#146ADC]"></span>{" "}
                  All
                </button>
                <button
                  onClick={() => handleClick("APPROVED")}
                  className={`${
                    activeBtn === "APPROVED"
                      ? "text-[#2DD683] border border-[#2DD683]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#2DD683]"></span>{" "}
                  APPROVED
                </button>

                <button
                  onClick={() => handleClick("PENDING")}
                  className={`${
                    activeBtn === "PENDING"
                      ? "text-[#FFC107] border border-[#FFC107]"
                      : ""
                  }  !rounded-[4px]   flex items-center gap-x-5 py-1 px-5 font-[500]`}
                >
                  <span className="w-[7px] h-[7px] rounded-full bg-[#FFC107]"></span>{" "}
                  PENDING
                </button>
              </div>

              <div
                className="cursor-pointer flex items-center justify-center mt-[5px]"
                onClick={() => fetchTableData(0, 10)}
              >
                <img src={svg67} alt="svg67" />
              </div>

              <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
                <section>
                  <Table
                    rowSelection={false}
                    className="mt-[1.31rem] w-full"
                    scroll={{
                      x: 800,
                    }}
                    rowKey={(record) => record?.mrId}
                    columns={columns}
                    dataSource={receiptData}
                    loading={loading}
                    pagination={{
                      position: ["bottomCenter"],
                      current: pageIndex + 1,
                      total: receiptCount,
                      pageSize: pageSize,
                      onChange: (page, size) => {
                        setPageIndex(page - 1);
                        setPageSize(size);
                        fetchTableData(page - 1, size);
                      },
                      showSizeChanger: false,
                      hideOnSinglePage: true,
                    }}
                  />
                </section>
              </div>
            </div>
          </div>
        </div>
        <FilterModal
          isModalOpen={open}
          handleCancel={handleCancel}
          formData={formData}
          setFormData={setFormData}
          filters={filters}
          setFilters={setFilters}
        />
        <ManualReceiptModal
          handleFetchData={fetchTableData}
          open={openAdd}
          handleCancel={handleCancelAdd}
          prodd={prodd}
        />
        <DeleteModal
          isModalOpen={isModalOpenDelete}
          setIsModalOpen={setIsModalOpenDelete}
          prodd={prodd}
          handleDelete={handleDelete}
          loading={loading}
          content={`Are you sure you want to delete receipt  ${dateForHumans(prodd?.mrReceiptDate)} `}
          title={`Delete Receipt  ${dateForHumans(prodd?.mrReceiptDate)}`}
        />
      </div>
    </>
  );
}

export default ManualReceiptTable;
